import $ from 'jquery';
import { $body } from '../utils/globals';
import  plansSubmitButton from "./plan-form";


$('.js-load-more').on("click", function (e) {
    e.preventDefault();

    if ($.active > 0) {
        return;
    }

    let $button = $(this);
    let $ajaxContainer = $button.parent();
    let elementsContainerClass = $button.data("load-more-container");
    let $elementsContainer = $(elementsContainerClass);
    let nextPage = $button.data('paged');
    let maxPage = $button.data('max');
    let target = $button.data('item');

    if (typeof maxPage === 'undefined') {
        return;
    }

    $.ajax({
        url: window.location.href,
        type: "GET",
        data: {
            'crb_paged': nextPage,
        },
        beforeSend: function () {
            $elementsContainer.addClass('is-loading');
        },
        success: function (response) {
            const $newItems = $(response)
                .find(elementsContainerClass)
                .find(target);

            $newItems.appendTo($elementsContainer);

            if ($(response).find('[data-load-more]').length) {
                const newRequestUrl = $(response)
                    .find('[data-load-more]')
                    .attr("href");
                $button.attr("href", newRequestUrl);
                $button.data('paged', nextPage + 1);
            } else {
                $button.remove();
            }

            $('.js-plan-submit-btn[disabled]').removeAttr('disabled');
            $('.js-roaming-plan-submit-btn[disabled]').removeAttr('disabled');
            plansSubmitButton();
        },
        error: function () {
            $ajaxContainer.html(
                "<h3>Error has occurred please try again!</h3>"
            );
        },
        complete: function () {
            $elementsContainer.removeClass('is-loading');
        },
    });
});